import * as css from "~/components/VerdictCard.css";
import { formatConfidence } from "~/lib/confidence";
import type { Verdict } from "~/lib/tasks";

export interface VerdictCardProps {
  verdict: Verdict;
}

/**
 * VerdictCard renders the verdict a system verify task produced, shown on its
 * human review task (TMF-198, TMF-202): the tool that produced it, its bare
 * conclusion (or an error state when the task was blocked), optional confidence,
 * and a one-line detail. Read-only — the specialist acts by approving (Mark
 * done) or rejecting the review task itself.
 */
export function VerdictCard({ verdict }: VerdictCardProps) {
  const { tool, conclusion, confidence, detail, status } = verdict;
  const isError = status === "error";

  return (
    <div className={css.panel}>
      <div className={css.header}>
        <span className={css.title}>{tool}</span>
        {typeof confidence === "number" ? (
          <span className={css.detail}>{formatConfidence(confidence)} confidence</span>
        ) : null}
      </div>

      <div className={css.field}>
        <span className={css.label}>{isError ? "Status" : "Conclusion"}</span>
        <span className={css.value}>{isError ? "Error — needs manual review" : conclusion || "—"}</span>
      </div>

      {detail ? <p className={css.detail}>{detail}</p> : null}
    </div>
  );
}
